import { ChangeDetectorRef, Component } from '@angular/core';
import { SharedModule } from '../../core/shared.module';
import {
  AnagraficaTimesheet,
  StatoPresaVisioneTimesheet,
  Timesheet,
} from '../../interfaces/timesheet.interface';
import { TabellaCommesseComponent } from '../../shared/components/tabella-commesse/tabella-commesse.component';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { AppService } from '../../service/app.service';
import { LoaderService } from '../../service/loader.service';
import { NotificationService } from '../../service/notification.service';
import { Utente } from '../../interfaces/user';
import { RisorseService } from '../../service/risorse.service';
import { Risorsa } from '../../interfaces/risorse.interface';
import { StatoPresaVisioneTimesheetEnum } from '../../shared/enum/statopresavisione.enum';
import { of, Subscription, switchMap } from 'rxjs';
import { tipologicaInterface } from '../../interfaces/tipologica.interface';
import { ConfirmationModal } from '../../shared/components/confirmationModal/confirmation.modal';
import { Attori } from '../../shared/enum/attori.enum';
import { RettificheService } from '../../service/rettifiche.service';
import { ModificaModalData } from '../../interfaces/modal.interface';
import { ModificaModalComponent } from '../../shared/components/modifica-modal/modifica-modal.component';
import { ElencoRisorseService } from '../../service/elenco-risorse.service';
import { TabellaModificheComponent } from '../../shared/components/tabella-modifiche/tabella-modifiche.component';
import { Rettifica } from '../../interfaces/rettifica.interface';
import { Location } from '@angular/common';
import { TimesheetService } from '../../service/timesheet.service';
import { GestioneTimesheetControllerComponent } from '../../shared/components/controller/gestione-timesheet-controller/gestione-timesheet-controller.component';

@Component({
  selector: 'app-dettaglio-risorsa',
  standalone: true,
  templateUrl: './dettaglio-risorsa.component.html',
  imports: [SharedModule, TabellaCommesseComponent, TabellaModificheComponent],
})
export class DettaglioRisorsaComponent {
  timesheet: Timesheet[] = [];
  anagraficaTimesheet: AnagraficaTimesheet | null = null;
  presaVisione: StatoPresaVisioneTimesheet | null = null;
  statiPresaVisione = StatoPresaVisioneTimesheetEnum;
  motivazioniList: tipologicaInterface[] = [];
  richiesteModifica: any[] = [];
  utente: Utente = this.appService.user;
  risorsa: Risorsa = this.risorseService.risorsa;
  pageSubscriptions: Subscription = new Subscription();
  attore: number = this.appService.attore;
  attori = Attori;
  commesseErrate: tipologicaInterface[] = [];
  livello: string = '';
  giorniModificati: any;

  constructor(
    private loaderService: LoaderService,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private notificationService: NotificationService,
    private appService: AppService,
    private risorseService: RisorseService,
    private rettificheService: RettificheService,
    private elencoRisorseService: ElencoRisorseService,
    private timesheetService: TimesheetService,
    private cd: ChangeDetectorRef,
    private location: Location,
  ) {}

  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.route.data.subscribe((data) => {
      this.timesheet = data['data'].risorsa;
      this.anagraficaTimesheet = data['data'].anagraficaTimeSheet;
      this.presaVisione = data['data'].statoPresaVisioneTimesheet;
      this.commesseErrate = this.timesheet
        .filter(
          ({ tipologia, coincidenza }) =>
            coincidenza !== false &&
            ![
              'PRESENZA',
              'ASSENZA',
              'STRAORDINARIO',
              'TRASFERTA',
              'ENT_ND',
            ].includes(tipologia)
        )
        .map(({ tipologia, descrizioneCommessa }) => ({
          id: tipologia,
          descrizione: descrizioneCommessa,
        }));
      this.richiesteModifica = data['data'].richiesteModifica;
      this.giorniModificati = data['data'].giorniModificati;
      if (this.richiesteModifica[0]?.timestamp)
        this.appService.timestamp = this.richiesteModifica[0]?.timestamp;
    });
    this.livello = this.timesheet?.find(t => t.livello != null && t.livello !== '')?.livello ?? '';
    this.loaderService.hide();
  }

  goBack(): void {
    this.loaderService.show();
    this.location.back();
  }

  apriModaleModifica(rettifica: Rettifica | null = null) {
    // const commesseErrateIds = this.commesseErrate.map(c => c.id);
    const data: ModificaModalData = {
      // commesse: this.elencoRisorseService.commesse.filter(
      //   c => !commesseErrateIds.includes(c.id)
      // ),
      commesse: this.elencoRisorseService.commesse,
      commesseErrate: this.commesseErrate,
      matricola: this.presaVisione?.risorsa,
      anno: this.anagraficaTimesheet?.anno,
      mese: this.anagraficaTimesheet?.mese,
      periodo: this.anagraficaTimesheet?.periodo ?? '',
      rettifica: rettifica,
    };

    this.dialog
      .open(ModificaModalComponent, {
        data,
        autoFocus: false,
        disableClose: true,
        width: 'calc(100% - 30px)',
        maxWidth: '700px',
      })
      .afterClosed()
      .pipe(
        switchMap((val) => {
          if (val) {
            this.loaderService.show();
            return this.rettificheService.getGiorniModificheRisorsa();
          }
          return of(null);
        }),
        switchMap((val) => {
          if (val) {
            this.giorniModificati = val;
            return this.rettificheService.getModificheRisorsa();
          }
          return of(null);
        })
      )
      .subscribe({
        next: (val) => {
          if (val) {
            this.richiesteModifica = val;
            this.appService.timestamp = this.richiesteModifica[0]?.timestamp ?? '';
            this.notificationService.success(
              `Richiesta di modifica ${
                rettifica ? 'aggiornata' : 'inserita'
              } correttamente`,
              5000
            );
          }
        },
        complete: () => this.loaderService.hide(),
        error: () => this.loaderService.hide(),
      });
  }

  iconClick(event: any) {
    if (event.columnDef === 'rimuovi') {
      this.dialog
        .open(ConfirmationModal, {
          data: {
            title: 'Elimina richiesta',
            text: 'Sei sicuro di voler eliminare la richiesta selezionata?',
          },
          autoFocus: false,
          disableClose: true,
          width: 'calc(100% - 30px)',
          maxWidth: '600px',
        })
        .afterClosed()
        .pipe(
          switchMap((val) => {
            if (val) {
              this.loaderService.show();
              return this.rettificheService.deleteRettifica(event.item.id);
            }
            return of(null);
          }),
          switchMap((val) => {
            if (val) {
              return this.rettificheService.getGiorniModificheRisorsa();
            }
            return of(null);
          }),
          switchMap((val) => {
            if (val) {
              this.giorniModificati = val;
              return this.rettificheService.getModificheRisorsa();
            }
            return of(null);
          })
        )
        .subscribe({
          next: (val) => {
            if (val) {
              this.richiesteModifica = val;
              this.appService.timestamp = this.richiesteModifica[0]?.timestamp ?? '';
              this.notificationService.success(
                'Richiesta di modifica eliminata correttamente',
                5000
              );
            }
          },
          complete: () => this.loaderService.hide(),
          error: () => this.loaderService.hide(),
        });
    }
    if (event.columnDef === 'modifica') {
      const rettifica: Rettifica | null = event.item;
      this.apriModaleModifica(rettifica);
    }
  }

  approvazioneTimesheet() {
    const dialogRef = this.dialog.open(ConfirmationModal, {
      data: {
        title: 'Attenzione',
        text: `L'approvazione ha effetto sul Timesheet di ${this.risorsa.nomeRisorsa}.`,
      },
      autoFocus: false,
      disableClose: true,
      width: 'calc(100% - 30px)',
      maxWidth: '600px',
    });
    this.pageSubscriptions.add(
      dialogRef
      .afterClosed()
      .pipe(
        switchMap((result) => {
          if (!result) {
            return of(null);
          }
          this.loaderService.show();
          return this.elencoRisorseService.approvaRisorsa([
            this.presaVisione?.risorsa,
          ]);
        }),

        switchMap((result) => {
          if (result) {
            return this.timesheetService.getDettaglioStatoPresaVisioneTimesheet();
          }
          return of(null);
        }),
        switchMap((result) => {
          if (result) {
            this.presaVisione = result;
            return this.rettificheService.getModificheRisorsa();
          }
          return of(null);
        }),
      )
      .subscribe({
        next: (result) => {
          if (result) {
            this.notificationService.success(
              'Operazione completata con successo',
              5000
            );
            this.richiesteModifica = result;
            this.cd.detectChanges();
          }
        },
        error: () => this.loaderService.hide(),
        complete: () => this.loaderService.hide(),
      })
    );
  }

  ngOnDestroy(): void {
    this.pageSubscriptions.unsubscribe();
  }
}
